import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import InputCheckbox from 'components/atoms/inputs/input-checkbox';

interface Props {
    dispatch;
    isChecked: boolean;
}

class LimitOnePitcherPerGame extends Component<Props> {
    onChange(isChecked) {
        this.props.dispatch(Action.do('setLimitOnePitcherPerGame', isChecked));
    }

    render() {
        const {isChecked} = this.props;

        return (
            <div>
                <InputCheckbox
                    label="Limit 1 Pitcher per game"
                    checked={isChecked}
                    onChange={this.onChange.bind(this)}
                />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters} = state.lineupsData;

    return {
        isChecked: filters.limitOnePitcherPerGame,
    };
}

export default connect(mapStatesToProps)(LimitOnePitcherPerGame);
